import React from 'react'
import Link from '../components/IntlLink'
import HomeSlider from '../components/HomeSlider'
import PropTypes from 'prop-types'
import Intro from '../components/Intro'
import getTransitionStyle from '../utils/getTransitionStyle'
import { HelmetDatoCms } from 'gatsby-source-datocms'

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isIntroVisible: props.transition && !props.transition.previousPathname,
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  render() {
    const { data, transition } = this.props
    const slides = data.home.slider
    const status = transition ? transition.status : "entering"
    const isIntroActive = transition && !transition.previousPathname

    const pageAppear = getTransitionStyle(
      status, 500, isIntroActive ? 2600 : 0, 'bgAppear'
    )

    return (
      <div className="intro__overflow">
        {
          this.state.isIntroVisible &&
            <Intro transition={transition}/>
        }
        {
          this.state.isIntroVisible &&
            <div
              className="intro__background"
              style={pageAppear}
            />
        }
        <HelmetDatoCms
          seo={data.home.seo}
          favicon={data.site.favicon}
        />
        <HomeSlider
          slides={slides}
          shuffleSlides={data.home.shuffleSlides}
          randomizeCollection={data.home.randomizeCollection}
          transition={transition}
          delay={isIntroActive ? 2900 : 0}
          menuData={data}
        />
      </div>
    )
  }
}

IndexPage.propTypes = {
  transition: PropTypes.object,
}

export default IndexPage
export const query = graphql`
  query HomeQuery($locale: String!) {
    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    home: datoCmsHomepage(locale: { eq: $locale }) {
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      shuffleSlides
      randomizeCollection
      slider {
        id
        image {
          title
          alt
          resize(width: 1100, imgixParams: { auto: "compress" }) {
            src
          }
        }
        slideTitle
        link
        buttonText
        color {
          hex
        }
        collection {
          id
          slug
          name
          color {
            hex
          }
          combos {
            baseBits {
              designer {
                name
              }
            }
            optionalBits {
              designer {
                name
              }
            }
          }
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/index.js